export default __webpack_public_path__ + "static/media/005-right-arrow.d457cd0b.png";